var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockchainConsulting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 401.392,
    height: 501.628,
    viewBox: "0 0 401.392 501.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_335",
    "data-name": "Grupo 335",
    transform: "translate(-2684.995 -2758.052)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_182",
    "data-name": "Elipse 182",
    cx: 60.571,
    cy: 60.571,
    r: 60.571,
    transform: "translate(2869.306 2923.26)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_183",
    "data-name": "Elipse 183",
    cx: 78.033,
    cy: 78.033,
    r: 78.033,
    transform: "translate(2851.844 2905.797)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1121",
    "data-name": "Caminho 1121",
    d: "M2732.063,2792.349v38.134h163.329v50.186",
    transform: "translate(34.486 25.129)",
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1122",
    "data-name": "Caminho 1122",
    d: "M2704.452,2983.91v-95.551h133.135",
    transform: "translate(14.256 95.472)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_315",
    "data-name": "Linha 315",
    x1: 148.678,
    transform: "translate(2718.708 2937.089)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_184",
    "data-name": "Elipse 184",
    cx: 10.399,
    cy: 10.399,
    r: 10.399,
    transform: "translate(2708.309 2926.69)",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_185",
    "data-name": "Elipse 185",
    cx: 10.399,
    cy: 10.399,
    r: 10.399,
    transform: "translate(2756.149 2926.69)",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_186",
    "data-name": "Elipse 186",
    cx: 10.399,
    cy: 10.399,
    r: 10.399,
    transform: "translate(2803.989 2926.69)",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_187",
    "data-name": "Elipse 187",
    cx: 10.399,
    cy: 10.399,
    r: 10.399,
    transform: "translate(2919.478 2846.781)",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_188",
    "data-name": "Elipse 188",
    cx: 10.399,
    cy: 10.399,
    r: 10.399,
    transform: "translate(2756.149 2846.781)",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1123",
    "data-name": "Caminho 1123",
    d: "M2901.365,2933.395v56.448H2723.91",
    transform: "translate(28.513 128.469)",
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_142",
    "data-name": "Ret\\xE2ngulo 142",
    width: 18.659,
    height: 18.659,
    transform: "translate(2740.816 3006.258)",
    fill: "#63c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_143",
    "data-name": "Ret\\xE2ngulo 143",
    width: 18.659,
    height: 18.659,
    transform: "translate(2775.947 3006.258)",
    fill: "#63c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_144",
    "data-name": "Ret\\xE2ngulo 144",
    width: 18.659,
    height: 18.659,
    transform: "translate(2811.078 3006.258)",
    fill: "#63c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_145",
    "data-name": "Ret\\xE2ngulo 145",
    width: 18.659,
    height: 18.659,
    transform: "translate(2740.816 3039.03)",
    fill: "#63c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_146",
    "data-name": "Ret\\xE2ngulo 146",
    width: 18.659,
    height: 18.659,
    transform: "translate(2775.947 3039.03)",
    fill: "#63c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_147",
    "data-name": "Ret\\xE2ngulo 147",
    width: 18.659,
    height: 18.659,
    transform: "translate(2811.078 3039.03)",
    fill: "#63c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_148",
    "data-name": "Ret\\xE2ngulo 148",
    width: 18.659,
    height: 18.659,
    transform: "translate(2775.947 3070.053)",
    fill: "#63c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_149",
    "data-name": "Ret\\xE2ngulo 149",
    width: 18.659,
    height: 18.659,
    transform: "translate(2811.078 3070.053)",
    fill: "#63c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_150",
    "data-name": "Ret\\xE2ngulo 150",
    width: 18.659,
    height: 18.659,
    transform: "translate(2811.078 3240.021)",
    fill: "#63c"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_316",
    "data-name": "Linha 316",
    y2: 151.309,
    transform: "translate(2820.407 3088.712)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_317",
    "data-name": "Linha 317",
    x2: 170.041,
    transform: "translate(2820.407 3182.05)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_318",
    "data-name": "Linha 318",
    y2: 245.533,
    transform: "translate(3040.46 2862.38)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1124",
    "data-name": "Caminho 1124",
    d: "M2746.914,2775.2h248.179v64.216",
    transform: "translate(45.367 12.565)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_319",
    "data-name": "Linha 319",
    x2: 22.15,
    transform: "translate(3007.91 2983.831)",
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_189",
    "data-name": "Elipse 189",
    cx: 10.399,
    cy: 10.399,
    r: 10.399,
    transform: "translate(3030.061 2973.432)",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_320",
    "data-name": "Linha 320",
    x2: 27.768,
    transform: "translate(3026.576 2851.981)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_321",
    "data-name": "Linha 321",
    x2: 27.768,
    transform: "translate(3026.576 2862.38)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_274",
    "data-name": "Grupo 274",
    transform: "translate(2740.816 2758.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_273",
    "data-name": "Grupo 273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1125",
    "data-name": "Caminho 1125",
    d: "M2742.944,2758.052l-25.732,14.857v29.713l25.732,14.856,25.732-14.856v-29.713Z",
    transform: "translate(-2717.211 -2758.052)",
    fill: "#63c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_276",
    "data-name": "Grupo 276",
    transform: "translate(2684.995 3079.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_275",
    "data-name": "Grupo 275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1126",
    "data-name": "Caminho 1126",
    d: "M2718.709,2943.505l-33.714,19.465v38.93l33.714,19.465,33.713-19.465v-38.93Z",
    transform: "translate(-2684.995 -2943.505)",
    fill: "#63c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_278",
    "data-name": "Grupo 278",
    transform: "translate(2700.878 3097.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_277",
    "data-name": "Grupo 277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1127",
    "data-name": "Caminho 1127",
    d: "M2713.416,2955.734l-17.831,10.295v20.589l17.831,10.294,17.832-10.294v-20.589Z",
    transform: "translate(-2695.585 -2955.734)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_190",
    "data-name": "Elipse 190",
    cx: 36.343,
    cy: 36.343,
    r: 36.343,
    transform: "translate(2893.535 2947.488)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_279",
    "data-name": "Grupo 279",
    transform: "translate(2990.448 3118.312)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_151",
    "data-name": "Ret\\xE2ngulo 151",
    width: 94.939,
    height: 140.368,
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_322",
    "data-name": "Linha 322",
    x2: 56.083,
    transform: "translate(19.427 27.956)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_323",
    "data-name": "Linha 323",
    x2: 56.083,
    transform: "translate(19.427 40.022)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_324",
    "data-name": "Linha 324",
    x2: 56.083,
    transform: "translate(19.427 52.087)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_325",
    "data-name": "Linha 325",
    x2: 56.083,
    transform: "translate(19.427 64.152)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_326",
    "data-name": "Linha 326",
    x2: 56.083,
    transform: "translate(19.427 76.217)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_327",
    "data-name": "Linha 327",
    x2: 56.083,
    transform: "translate(19.427 88.282)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_328",
    "data-name": "Linha 328",
    x2: 56.083,
    transform: "translate(19.427 100.348)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_329",
    "data-name": "Linha 329",
    x2: 56.083,
    transform: "translate(19.427 112.413)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1128",
    "data-name": "Caminho 1128",
    d: "M2904.944,2970.371a10.4,10.4,0,1,0-20.8,0",
    transform: "translate(145.915 147.942)",
    fill: "none",
    stroke: "#63c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_281",
    "data-name": "Grupo 281",
    transform: "translate(2914.513 2967.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_280",
    "data-name": "Grupo 280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1129",
    "data-name": "Caminho 1129",
    d: "M2832.823,2878.878l-15.364,8.87v17.741l15.364,8.871,15.364-8.871v-17.741Z",
    transform: "translate(-2817.46 -2878.878)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainConsulting);
export default __webpack_public_path__ + "static/media/blockchain_consulting.68afb7ba1ff5613104f9116e02bf8b07.svg";
export { ForwardRef as ReactComponent };